import recruitmentGetters from "./getters.js";
import recruitmentMutations from "./mutations.js";
import recruitmentActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      industriesTimestamp: null,
      // Reference data from recruitmentdb.industries — each carries the
      // master documentation, skills, roles and specialisation lists that a
      // job and a user's profile are both written from.
      industries: [],
      jobsTimestamp: null,
      // True only while a jobs fetch is in flight, so a failed request clears
      // the loading state instead of leaving the table on a skeleton forever.
      jobsLoading: false,
      clientsTimestamp: null,
      // The companies this company recruits for. The owning company itself is
      // NOT in here — the Client dropdown adds it as the '(Internal)' option.
      clients: [],
      // The company's own job posts, newest first — the Marketplace list.
      jobs: [],
      rightsToWorkOptions: [
        "Citizen",
        "Permanent Resident",
        "Temporary Visa",
        "Student Visa",
        "Working Holiday Visa",
        "Employer Sponsored Visa",
        "Bridging Visa",
        "Humanitarian Visa",
        "Other Visa",
        "No Work Rights",
        "Not Verified",
      ],
      // The subset that can carry an expiry date. Mirrors
      // RIGHTS_TO_WORK_WITH_EXPIRY in back_end/src/recruitment/job_options.js,
      // which is what actually enforces it — a date sent against any other
      // type is refused with a 400.
      rightsToWorkVisaOptions: [
        "Temporary Visa",
        "Student Visa",
        "Working Holiday Visa",
        "Employer Sponsored Visa",
        "Bridging Visa",
        "Humanitarian Visa",
        "Other Visa",
      ],
      standardDocumentation: [
        "Identification", 
        "Police Check",
        "NDIS Worker Screening Check",
      ],
    };
  },
  getters: recruitmentGetters,
  mutations: recruitmentMutations,
  actions: recruitmentActions,
};
